import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import theme from "styles/theme"
import Container from "components/Container"
import BlockHeader from "components/BlockHeader"
import ScrollIndicator from "components/ScrollIndicator"
import HighlightCard from 'components/cards/HighlightCard'

const expand = styles =>
  theme.expandQueries(styles, ["root", theme.tabletSmall, theme.mobile])

const HighlightCardsBlock = ({
  context,
  id,
  label,
  title,
  description,
  highlightCards,
  scrollIndicator,
}) => {
  return (
    <div
      className="highlightCardsBlock">
      <Container
        max={943}
        wrapperStyles={{
          "--inlinePadding": "64px",
          padding: "0 var(--inlinePadding)",
          [theme.mobile]: {
            "--inlinePadding": "30px",
          },
          [theme.smallMobilePortrait]: {
            "--inlinePadding": "20px",
          },
          backgroundColor: theme.lightGray,
        }}
        css={[
          expand({ padding: ["85px 0", "60px 10px", "35px 10px"] }),
        ]}
      >
        <BlockHeader label={label} title={title} />
        {description && (
          <div
            css={{
              ...theme.bodyCopy,
              maxWidth: 746,
              textAlign: "center",
              margin: "34px auto 0",
              [theme.tablet]: { marginTop: 24 },
            }}
          >
            {description}
          </div>
        )}
        <div
          css={{
            display: "grid",
            gridTemplateColumns: "repeat(2, minmax(auto, 354px))",
            justifyContent: "center",
            gap: 38,
            paddingTop: 50,
            [theme.tablet]: {
              gap: 10,
            },
            [theme.mobile]: {
              gridTemplateColumns: "repeat(2, minmax(auto, 354px))",
            },
            [theme.mobilePortrait]: {
              gridTemplateColumns: "1fr",
            },
          }}
        >
          {highlightCards.map((card, index) => (
            <HighlightCard
              key={`highlight-card-${index}`}
              iconType={card.iconType}
              iconLikeText={card.iconLikeText}
              iconSvg={card?.iconSvg?.asset?.svg?.content}
              iconDesc={card.iconDesc}
            />
          ))}
        </div>
        {scrollIndicator && (
          <ScrollIndicator
            fragment={context.nextSectionId}
            css={expand({
              transform: [
                "translateY(45px)",
                "translateY(30px)",
                "translateY(20px)",
              ],
              paddingTop: [10, 20, 30],
            })}
          >
            {scrollIndicator}
          </ScrollIndicator>
        )}
      </Container>
    </div>
  )
}

export default HighlightCardsBlock

HighlightCardsBlock.propTypes = {
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  highlightCards: PropTypes.arrayOf(
    PropTypes.shape({
      iconType: PropTypes.string,
      iconLikeText: PropTypes.string,
      iconSvg: PropTypes.shape({
        asset: PropTypes.shape({
          svg: PropTypes.shape({
            content: PropTypes.string.isRequired,
          }).isRequired,
        }).isRequired,
      }),
      iconDesc: PropTypes.string,
    })
  ).isRequired,
  scrollIndicator: PropTypes.string,
}

export const query = graphql`
	fragment HighlightCardsBlock on SanityHighlightCardsBlock {
    label
    title
    description
    highlightCards {
      # _key
      iconType
      iconLikeText
      iconSvg {
        asset {
          svg {
            content
          }
        }
      }
      iconDesc
    }
    scrollIndicator
	}
`
